import React, { useEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const RichTooltip = () => {
  useEffect(() => {
    let root = am5.Root.new("rich-tooltip-chart");

    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
      })
    );

    let xAxis = chart.xAxes.push(
      am5xy.DateAxis.new(root, {
        maxDeviation: 0.1,
        baseInterval: {
          timeUnit: "day",
          count: 1,
        },
        renderer: am5xy.AxisRendererX.new(root, {}),
      })
    );

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        maxDeviation: 0.1,
        renderer: am5xy.AxisRendererY.new(root, {}),
      })
    );

    let series = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "Series",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "value",
        valueXField: "date",
        tooltip: am5.Tooltip.new(root, {
          getFillFromSprite: false,
          getStrokeFromSprite: false,
          autoTextColor: false,
          labelText: "[bold]{date.formatDate()}[/]\n[bold]{value}[/]",
          html: `<div style="padding: 10px;">
                    <table style="width: 100%; border-collapse: collapse;">
                      <tr>
                        <th>Date</th>
                        <th>Value</th>
                      </tr>
                      <tr>
                        <td style="border: 1px solid #ccc;">{date.formatDate()}</td>
                        <td style="border: 1px solid #ccc;">{value}</td>
                      </tr>
                    </table>
                    <img src="https://placehold.jp/150x150.png" alt="Example Image" style="width: 100%; margin-top: 10px;" />
                    <div style="background: red; width: 10px; height: 10px; border-radius: 50%; margin-top: 10px;"></div>
                  </div>`,
        }),
      })
    );

    series.data.setAll([
      { date: new Date(2023, 0, 1).getTime(), value: 100 },
      { date: new Date(2023, 0, 2).getTime(), value: 120 },
      { date: new Date(2023, 0, 3).getTime(), value: 140 },
    ]);

    chart.set("cursor", am5xy.XYCursor.new(root, {}));

    return () => {
      root.dispose();
    };
  }, []);

  return <div id="rich-tooltip-chart" style={{ width: "100%", height: "500px" }}></div>;
};

export { RichTooltip };
